import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { COMPANY } from "../data/site";
import PageHero from "../components/common/PageHero";
import Reveal from "../components/common/Reveal";
import ContactForm from "../components/forms/ContactForm";
import useSeo from "../hooks/useSeo";

const items = [
  { icon: Mail, label: "Email", value: COMPANY.email, href: `mailto:${COMPANY.email}` },
  { icon: Phone, label: "Phone (Ireland)", value: COMPANY.phone, href: `tel:${COMPANY.phone.replace(/\s/g, "")}` },
  { icon: Phone, label: "Phone (UK)", value: COMPANY.phoneUk, href: `tel:${COMPANY.phoneUk.replace(/\s/g, "")}` },
  { icon: MapPin, label: "Address", value: COMPANY.address },
  { icon: Clock, label: "Office hours", value: COMPANY.hours },
];

export default function Contact() {
  useSeo({
    title: "Contact Us",
    description:
      "Get in touch with Azimi & Co. Vision Recruitment. Whether you are hiring, seeking a healthcare role, or exploring a recruitment partnership, we would be glad to hear from you.",
  });
  return (
    <>
      <PageHero
        overline="Contact"
        title="Let's start a conversation"
        description="Whether you are hiring, seeking your next role, or exploring a partnership, our team would be glad to hear from you."
      />
      <section className="py-20 lg:py-24">
        <div className="mx-auto grid max-w-7xl gap-12 px-6 lg:grid-cols-5 lg:gap-16 lg:px-8">
          <Reveal className="lg:col-span-2">
            <h2 className="font-serif text-2xl text-navy">Get in touch</h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">
              Use the form or reach us directly. We aim to respond as promptly as possible.
            </p>
            <ul className="mt-8 space-y-5">
              {items.map(({ icon: Icon, label, value, href }) => (
                <li key={label} className="flex items-start gap-4 rounded-xl border border-border bg-white p-4">
                  <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-navy/5 text-navy">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <p className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
                    {href ? (
                      <a href={href} className="text-sm font-medium text-charcoal hover:text-gold">{value}</a>
                    ) : (
                      <p className="text-sm font-medium text-charcoal">{value}</p>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={100} className="lg:col-span-3">
            <div className="rounded-2xl border border-border bg-white p-6 shadow-sm sm:p-8">
              <ContactForm />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
